<h1 class="text-xl font-semibold text-gray-900">Logs</h1>

<div class="mt-6 overflow-hidden rounded-lg bg-white shadow">
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Date
          </th>
          <th
            scope="col"
            class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
          >
            Action
          </th>
        </tr>
      </thead>

      <!-- Table content -->
      <tbody *ngIf="logs?.length; else loadingState" class="divide-y divide-gray-200 bg-white">
        <tr
          *ngFor="let log of logs"
          class="hover:bg-gray-50 transition-colors duration-100"
        >
          <td class="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
            {{ log.created_at | date: 'dd/MM/yyyy HH:mm' }}
          </td>
          <td class="px-4 py-2 text-sm text-gray-700">
            {{ log.description }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Loading / Empty state -->
  <ng-template #loadingState>
    <tbody class="bg-white">
      <tr *ngIf="submitted">
        <td colspan="2" class="py-6 text-center">
          <div class="flex justify-center items-center space-x-2">
            <div
              class="w-6 h-6 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"
            ></div>
            <span class="text-gray-500">Loading logs...</span>
          </div>
        </td>
      </tr>

      <tr *ngIf="!submitted && (!logs || logs.length === 0)">
        <td colspan="2" class="py-6 text-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="mx-auto h-8 w-8 text-gray-400 mb-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <span class="text-gray-500 text-sm"
            >No activity logs found for this user.</span
          >
        </td>
      </tr>
    </tbody>
  </ng-template>
</div>

<!-- Pagination -->
<nav class="mt-6 flex justify-center">
  <div class="inline-flex rounded-md shadow-sm isolate">
    <button
      (click)="goToPreviousPage()"
      [disabled]="!previousPageUrl"
      class="relative inline-flex items-center px-3 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 rounded-l-md disabled:opacity-50"
    >
      ‹
    </button>

    <button
      *ngFor="let page of pageNumbers"
      (click)="page !== '...' && loadLogs(page)"
      [disabled]="page === '...' || currentPage === page"
      [ngClass]="{
        'bg-indigo-500 text-white font-semibold': currentPage === page,
        'bg-white text-gray-700 hover:bg-gray-50': currentPage !== page && page !== '...',
        'cursor-default': page === '...'
      }"
      class="relative inline-flex items-center px-4 py-2 text-sm font-medium border border-gray-300"
    >
      {{ page }}
    </button>

    <button
      (click)="goToNextPage()"
      [disabled]="!nextPageUrl"
      class="relative inline-flex items-center px-3 py-2 text-sm font-medium border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 rounded-r-md disabled:opacity-50"
    >
      ›
    </button>
  </div>
</nav>
